import { useRef } from 'react';
import styled from '@emotion/styled';
import { scrollbarCss } from 'app/spacing';
import {
  useEndsOfYScroll,
  useScrollThreshold,
  GradientBottom,
  DropShadowTop,
  Loader,
  TableText as ListText,
} from './helpers';
import { mergeRefs } from '@kizen/kds/util';

const ListWrapper = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  &.in-modal {
    flex-basis: auto;
  }
  padding-top: 5px;
  overflow: auto;
  height: 100%;
  min-width: 335px;
  ${({ kdsCompat }) => (kdsCompat ? '' : scrollbarCss())}
`;

export default function LazyLoadList({
  className = '',
  loading,
  fetchingNextPage,
  onScrollThreshold,
  data,
  noDataMessage = '',
  children,
  loaderSize = 50,
  scrollContainerRef,
  // Adjust CSS to be compatible with KDS-style scrollbars
  kdsCompat = false,
  hideBottomGradient = false,
  ...others
}) {
  const listScrollRef = useRef(null);
  // Depend on templates so we calculate scroll bottom when layout's data and thereby its height updates
  const [scrolledTop, scrolledBottom] = useEndsOfYScroll(listScrollRef, [data]);
  useScrollThreshold(listScrollRef, [data], onScrollThreshold);

  return (
    <>
      <DropShadowTop fadeIn={!scrolledTop && children} />
      <ListWrapper
        className={className}
        ref={mergeRefs(listScrollRef, scrollContainerRef)}
        kdsCompat={kdsCompat}
        {...others}
      >
        {!loading && children}
        {fetchingNextPage || loading ? (
          <Loader loading size={loaderSize} />
        ) : null}
        {noDataMessage && !loading && data && data.length === 0 && (
          <ListText color="var(--color-font-placeholder)">
            {noDataMessage}
          </ListText>
        )}
        <GradientBottom
          fadeIn={!scrolledBottom && children && !hideBottomGradient}
        />
      </ListWrapper>
    </>
  );
}
